import { ProvidedNativeFunctions } from './Interfaces/ProvidedNativeFunctions';
import { SyncStatusInterface } from './Interfaces/SyncStatusInterface';
import { NativeBindingError } from './Errors';
import { Helper } from './Helper';

export default class CLSyncNativeBridge implements ProvidedNativeFunctions {
	private external = window.external as any;

	public ajax = (...params: any[]): void => {
		const [
			method,
			url,
			packedHeaders,
			data,
			saveasfile,
			userId,
			storeid,
			callbackid,
		] = params;
		if (!this.external || !this.external.ajax) throw new NativeBindingError('ajax');
		this.external.ajax(
			method,
			url,
			packedHeaders,
			data,
			saveasfile,
			userId,
			storeid,
			callbackid
		);
	};

	public writeTraceMessage = (...params: any[]): void => {
		const [message, now, userId = null, storeId = null] = params;
		if (!this.external || !this.external.writeTraceMessage) {
			throw new NativeBindingError('writeTraceMessage');
		}
		this.external.writeTraceMessage(message.toString(), now, userId, storeId);
	};
	public writeErrorMessage = (...params: any[]): void => {
		const [message, now, userId = null, storeId = null] = params;
		if (!this.external || !this.external.writeErrorMessage) {
			throw new NativeBindingError('writeErrorMessage');
		}
		this.external.writeErrorMessage(message.toString(), now, userId, storeId);
	};

	public notifyCLSyncStatus = (...params: any[]): void => {
		const syncStatus = params[0] as SyncStatusInterface;
		if (!this.external || !this.external.notifyCLSyncStatus) {
			throw new NativeBindingError('notifyCLSyncStatus');
		}
		this.external.notifyCLSyncStatus(Helper.stringifyJSON(syncStatus));
	};

	public getFile = (...params: any[]): void => {
		const [user, storeGuid, key, callbackId] = params;
		if (!this.external || !this.external.getFile) {
			throw new NativeBindingError('getFile');
		}
		this.external.getFile(user, storeGuid, key, callbackId);
	};

	public getAllFiles = (...params: any[]): void => {
		const [user, storeGuid, key, callbackId] = params;
		if (!this.external || !this.external.getAllFiles) {
			throw new NativeBindingError('getAllFiles');
		}
		this.external.getAllFiles(user, storeGuid, key, callbackId);
	};

	public saveFile = (...params: any[]): void => {
		const [user, storeGuid, key, file, callbackId] = params;
		if (!this.external || !this.external.saveFile) {
			throw new NativeBindingError('saveFile');
		}
		this.external.saveFile(user, storeGuid, key, file, callbackId);
	};

	public deleteFile = (...params: any[]): void => {
		const [user, storeGuid, key, callbackId] = params;
		if (!this.external || !this.external.deleteFile) {
			throw new NativeBindingError('deleteFile');
		}
		this.external.deleteFile(user, storeGuid, key, callbackId);
	};

	public deleteFolder = (...params: any[]): void => {
		const [user, storeGuid, key, callbackId] = params;
		if (!this.external || !this.external.deleteFolder) {
			throw new NativeBindingError('deleteFolder');
		}
		this.external.deleteFolder(user, storeGuid, key, callbackId);
	};

	public getMetadata = (...params: any[]): void => {
		const [user, storeGuid, key, callbackId] = params;
		if (!this.external || !this.external.getMetadata) {
			throw new NativeBindingError('getMetadata');
		}
		this.external.getMetadata(user, storeGuid, key, callbackId);
	};

	public saveMetadata = (...params: any[]): void => {
		const [user, storeGuid, key, metadata, callbackId] = params;
		if (!this.external || !this.external.saveMetadata) {
			throw new NativeBindingError('saveMetadata');
		}
		this.external.saveMetadata(user, storeGuid, key, metadata, callbackId);
	};

	public deleteMetadata = (...params: any[]): void => {
		const [user, storeGuid, key, callbackId] = params;
		if (!this.external || !this.external.deleteMetadata) {
			throw new NativeBindingError('deleteMetadata');
		}
		this.external.deleteMetadata(user, storeGuid, key, callbackId);
	};
	public ready = (): void => {
		this.external.ready();
	};
}
